import { TabList } from 'react-tabs';
import styled from 'styled-components/macro';

const StyledTablist = styled(TabList)`
  display: flex;
`;

export default StyledTablist;
